<template>
  <div>
    <div class="hero Ppchero page landscape">
      <!-- <div class="background"></div> -->
      <!-- <h1>Oferta Ppc</h1> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'PpcHero',
  props: {
    msg: String,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.Ppchero {
  background: url('/../ppc.jpg');
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  z-index: 1;
}
/* .background {
  position: absolute;
  min-width: 100%;
  min-height: 100%;
  background: #000;
  opacity: 0.3;
  z-index: -5;
} */
</style>
